<template>
  <div class="form-view__powered-by">
    Powered by
    <span title="Mandala Group">
      <!-- Mandala (imagen/parche-marca.py): sin enlace; quien llena un formulario viene de fuera. -->
      <Logo class="form-view__powered-by-logo" alt="Mandala Group" />
    </span>
  </div>
</template>
